import { React, useState, useEffect } from 'react'
import { MappedImage } from '../../Image'
import parse from 'html-react-parser'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'gatsby'

export const BlogContainer = ({ blogData, buttonText, subHeading }) => {
  const [selectedFilter, setSelectedFilter] = useState(null)
  const [selectedBlogs, setSelectedBlogs] = useState([])

  const re = /([^/]*$)/

  const filters = []
  blogData.map(blog => {
    filters.includes(blog.type) || filters.push(blog.type)
  })
  const sortedBlogData = blogData.sort((a, b) => {
    return new Date(b.datePublished) - new Date(a.datePublished)
  })

  useEffect(() => {
    setSelectedBlogs(
      sortedBlogData.filter(
        blog => blog.type === selectedFilter || selectedFilter === null
      )
    )
  }, [selectedFilter, sortedBlogData])

  return (
    <Container className="py-5">
      <Row>
        <Col lg={8}>
          {selectedBlogs.map(blog => {
            const splatRoute = blog?.internalTitle.match(re)
            return (
              <Row className="article-summary-wrapper" key={blog.title.title}>
                <div className="article-publish-date">
                  {new Date(blog.datePublished).toDateString()}
                </div>
                <div className="article-feature-image">
                  <MappedImage image={blog.featuredImage} />
                </div>
                <div className="article-summary-title">
                  {blog.title && parse(blog.title.title)}
                </div>
                <div className="article-summary-content">
                  {blog.description && parse(blog.description.description)}
                </div>
                <Link
                  href={`/news/${splatRoute[0]}`}
                  className="article-continue-reading"
                >
                  {buttonText}
                </Link>
              </Row>
            )
          })}
        </Col>
        <Col className="filter-container">
          <div
            className={`filter-button${!selectedFilter ? '-active' : ''}`}
            onClick={() => {
              setSelectedFilter(null)
            }}
          >
            {subHeading}
          </div>
          {filters.map(filter => (
            <div
              key={filter}
              className={`filter-button${
                filter === selectedFilter ? '-active' : ''
              }`}
              secondary
              onClick={() => {
                setSelectedFilter(filter)
              }}
            >
              {filter}
            </div>
          ))}
        </Col>
      </Row>
    </Container>
  )
}

export const mapBlogContainerProps = props => props
